import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import BarChart from '../Charts/BarChart';
import GraphLoader from '../../Assets/GraphLoader.gif';
import * as Icon from 'react-bootstrap-icons';

const BillDistribution = () => {

  const userState = useSelector(state => state.loginData.userData);
  const financialYear = useSelector(state => state?.activeData?.financialYear);

  const [months, setMonths] = useState([]);
  const [monthCounts, setMonthCounts] = useState([]);
  const [monthLoader, setMonthLoader] = useState(false);

  const [dates, setDates] = useState([]);
  const [dateCounts, setDateCounts] = useState([]);

  const [hours, setHours] = useState([]);
  const [hourCounts, setHourCounts] = useState([]);

  const labelMonth = useSelector(state => state.label.labelMonth);
  const labelDate = useSelector(state => state.label.labelDate);

  const [dateLoader, setDateLoader] = useState(false);
  const [hoursLoader, setHoursLoader] = useState(false);

  const currentDate = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().split("T")[0];
  const currentMonth = new Date().getMonth() + 1;

  useEffect(() => {
    getMonths();
  }, [financialYear])

  useEffect(() => {
    getDates(labelMonth)
  }, [labelMonth, financialYear])

  useEffect(() => {
    getHours(labelDate)
  }, [labelDate, financialYear])

  const getMonths = async () => {
    setMonthLoader(true);
    const payload = {
      financialYear: financialYear,
    };

    try {
      const response = await fetch(process.env.REACT_APP_BASE_URL + '/graph/monthwisecount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      
      if (result.status === 200 && result.months && result.months.length > 0) {
        setMonths(result.months);
        setMonthCounts(result.countOfMonth);
      } else {
        setMonths([]);
        setMonthCounts([]);
      }
    } catch (err) {
      console.log("Err while Get Monthwise Chart", err);
      setMonths([]);
      setMonthCounts([]);
    } finally {
      setMonthLoader(false);
    }
  }

  const getDates = async (labelMonth) => {
    setDateLoader(true);
    try {
      const response = await fetch(process.env.REACT_APP_BASE_URL + '/graph/datewisecount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          month: labelMonth ? labelMonth : currentMonth,
          financialYear: financialYear,
        })
      });
      const result = await response.json();
      
      if (result.status === 200 && result.dates && result.dates.length > 0) {
        setDates(result.dates);
        setDateCounts(result.countOfDate);
      } else {
        setDates([]);
        setDateCounts([]);
      }
    } catch (err) {
      console.log("Err while Get DateWise Chart", err);
      setDates([]);
      setDateCounts([]);
    } finally {
      setDateLoader(false);
    }
  }

  const getHours = async () => {
    setHoursLoader(true);
    try {
      const response = await fetch(process.env.REACT_APP_BASE_URL + '/graph/hourwisecount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          date: labelDate ? labelDate : currentDate,
          financialYear: financialYear,
        })
      });
      const result = await response.json();
      
      if (result.status === 200 && result.hours && result.hours.length > 0) {
        setHours(result.hours);
        setHourCounts(result.countOfHours);
      } else {
        setHours([]);
        setHourCounts([]);
      }
    } catch (err) {
      console.log("Err while Get HourWise Chart", err);
      setHours([]);
      setHourCounts([]);
    } finally {
      setHoursLoader(false);
    }
  }

  const handleDateLoader = () => {
    setDateLoader(true)
  }

  const handleHoursLoader = () => {
    setHoursLoader(true)
  }

  // No Data Found Component
  const NoDataFound = ({ message }) => (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "200px" }}>
      <Icon.BarChartFill size={60} color="#ccc" />
      <p className="text-muted mt-3 mb-0">{message || "No Data Found"}</p>
    </div>
  );

  return (
    <div className='BuildDistribution'>
      <Container>
        <Row className='justify-content-center'>
          <Col md={4}>
            <Card className="ChartCard" style={{ height: "250px", maxHeight: "250px", padding: '12px 0px 12px 0px' }}>
              <h6 className='mb-0'>Month Wise Distribution</h6>
              {monthLoader ? (
                <center className="mt-5">
                  <img src={GraphLoader} width="150" alt="Loading..." />
                </center>
              ) : months && months.length > 0 ? (
                <BarChart 
                  chartLabels={months} 
                  chartLabel="Month Counts" 
                  ColorArray='rgb(18, 103, 207, 0.4)' 
                  BorderArray='#073c7c'
                  chartData={monthCounts} 
                  chartHeading="Month Wise Distribution" 
                  handleDateLoader={() => { handleDateLoader() }} 
                  dateParam="date" 
                />
              ) : (
                <NoDataFound message="No month wise data available" />
              )}
            </Card>
          </Col>
        </Row>

        <Row className='justify-content-center mt-4 gx-5'>
          <Col md={12}>
            <Card className="ChartCard" style={{ height: "280px", maxHeight: "280px", padding: '22px 0px 20px 0px' }}>
              <h6 className='mb-0'>Date Wise Distribution</h6>
              <div><p style={{ background: 'linear-gradient(315deg, #ff3c00 0%, #ff8800 100%)' }}>Month-{labelMonth ? labelMonth : currentMonth}</p></div>
              {
                dateLoader ? (
                  <center>
                    <img src={GraphLoader} width="150" alt="Loading..." />
                  </center>
                ) : dates && dates.length > 0 ? (
                  <BarChart 
                    chartLabels={dates} 
                    chartLabel="Date Counts" 
                    ColorArray='rgba(255, 60, 0, 0.3)' 
                    BorderArray='#ff3c00'
                    chartData={dateCounts} 
                    chartHeading="Date Wise Distribution" 
                    handleDateLoader={() => { handleHoursLoader() }} 
                    dateParam="hours" 
                  />
                ) : (
                  <NoDataFound message="No date wise data available for selected month" />
                )
              }
            </Card>
          </Col>

          <Col md={5} className='my-4'>
            <Card className="ChartCard" style={{ height: "280px", maxHeight: "280px", padding: '25px 0px 20px 0px' }}>
              <h6>Hour Wise Distribution</h6>
              <div><p style={{ background: 'linear-gradient(315deg, #00b712, #40d400 100%)' }}>Date-{labelDate ? labelDate : currentDate}</p></div>
              {
                hoursLoader ? (
                  <center>
                    <img src={GraphLoader} width="150" alt="Loading..." />
                  </center>
                ) : hours && hours.length > 0 ? (
                  <BarChart 
                    chartLabels={hours} 
                    chartLabel="Hour Counts" 
                    ColorArray='rgba(0, 183, 18, 0.3)' 
                    BorderArray='#00B712'
                    chartData={hourCounts} 
                    chartHeading="Hour Wise Distribution" 
                  />
                ) : (
                  <NoDataFound message="No hour wise data available for selected date" />
                )
              }
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default BillDistribution;